import axios from "axios";
import { ProveedorModel, ProveedorSelectModel } from "../../pages/proveedores/models/ProveedorModel";
const API_URL = process.env.REACT_APP_API;

export async function obtenerProveedoresService() {
  try {
    const response = await axios.get(`${API_URL}proveedores`);
    const data = response.data.doc.data;
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function obtenerProveedoresSelect() {
  try {
    const response = await axios.get(`${API_URL}proveedores`);
    const data = response.data?.doc?.data?.rows || [];
    const select: ProveedorSelectModel[] = data.map((item: any) => ({
      id: Number(item.id),
      value: item.id,
      label: `${item.nombre}`,
      data: item,
    }));
    return select;
  } catch (error) {
    console.error("Error al obtener los proveedores:", error);
    throw error;
}}

export async function crearProveedorService(evento: ProveedorModel) {
  try {
    const { id, nombre, nombre_contacto, telefono } = evento;
    const url = `${API_URL}proveedores${id ? `/${id}` : ''}`;
    
    const response = id
      ? await axios.put(url, { nombre, nombre_contacto, telefono }) 
      : await axios.post(url, { nombre, nombre_contacto, telefono });
    
    return response;
  } catch (error) {
    console.error('Error al crear o editar el proveedor:', error);
    throw error;
  }
}

export async function obtenerProveedorPorIDService(id: number) {
  try {
    const response = await axios.get(`${API_URL}/proveedores/${id}`);
    let evento = response.data.doc.data;
    return evento;
  } catch (error) {
    console.log("ERROR: ", error);
    throw error;
  }
}


